import { Backdrop, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: "#fff",
}));

export default function LoadingOverlay({ loading }: { loading?: boolean }) {
  return (
    <StyledBackdrop open={loading !== false}>
      <CircularProgress color="inherit" />
    </StyledBackdrop>
  );
}
